import { z } from 'zod';

import { gatewayTypeSchema } from './gatewayType';
import {
  positionSchema,
  sensorModeSchema,
  sensorTypeSchema,
  woodScrewLengthMmSchema,
  woodTypeSchema,
} from './sensor';
export const installationTaskDeviceTypeSchema = z.preprocess(
  (value) => (typeof value === 'string' ? value.toUpperCase() : value),
  z.enum(['SENSOR', 'GATEWAY', 'VENTCAP'])
);
export const waterstopTypeSchema = z.enum(['waterguard', 'ctm', 'aquasafe']);

export type GatewayPosition = z.infer<typeof gatewayPositionSchema>;
export const gatewayPositionSchema = z.union([
  z.literal('onWall'),
  z.literal('onPole'),
  z.literal('insideCeiling'),
  z.literal('insideBox'),
  z.literal('other'),
]);

export type InstallationTask = z.infer<typeof installationTaskSchema>;
export const installationTaskSchema = z.object({
  installationTaskId: z.number(),
  installationId: z.number(),
  deviceType: installationTaskDeviceTypeSchema,
  isGateway: z.boolean(),
  actionType: z.string().max(16),
  sensorType: sensorTypeSchema.nullable().optional(),
  gatewayType: gatewayTypeSchema.nullable().optional(),
  sensorMode: sensorModeSchema.nullable().optional(),
  position: z.union([positionSchema, gatewayPositionSchema]).nullable().optional(),
  hasDevice: z.boolean(),
  coordinatesX: z.number().nullable().optional(),
  coordinatesY: z.number().nullable().optional(),
  isWaterguard: z.boolean().nullable().optional(),
  waterstopType: waterstopTypeSchema.nullable().optional(),
  temperatureAlertLevel: z.string().nullable().optional(),
  woodType: woodTypeSchema.nullable().optional(),
  woodScrewLengthMm: woodScrewLengthMmSchema.nullable().optional(),
  woodInsulatedElectrode: z.boolean().nullable().optional(),
  label: z.string().nullable().optional(),
  comment: z.string().nullable().optional(),
  activationOrder: z.number().int().nonnegative().nullable().optional(),
});
